import { analytics } from './analytics';
export const YANDEX_GOALS = {
    mainPage: 'flight_main_page',
    flightsPage: 'flight_flights_page',
    passengersPage: 'flight_passengers_page',
    detailsPage: 'flight_details_page',
    paymentPage: 'flight_payment_page',
    successPage: 'flight_success_page',
    flightsOverlapErrorShown: 'flight_overlap_error_shown',
    flightsOrderErrorShown: 'flight_order_error_shown',
    flightManualMoveClick: 'flight_manual_move_click',
    flightsAutoSortClick: 'flight_auto_sort_click',
};
export const reachAnalyticsGoal = (goal) => {
    analytics.sendEvent({ action: goal });
};
